<div i18n mat-dialog-title>Projekt</div>
<div mat-dialog-content>
  <form #formDirective="ngForm" [formGroup]="form">
    <div class="content">
      <app-autocomplete [formGroup]="form"
                        [innerWidth]="2"
                        [outerWidth]="2"
                        formName="name"></app-autocomplete>
      <app-newline></app-newline>
      <app-input-text [formGroup]="form"
                      [innerWidth]="2"
                      [outerWidth]="2"
                      formName="info"></app-input-text>
      <app-newline></app-newline>
      <app-slider
        [formGroup]="form"
        [innerWidth]="2"
        [labelFunc]="durationDisplay"
        [max]="maxDuration"
        [min]="0"
        [outerWidth]="2"
        formName="duration"></app-slider>
    </div>
    @if (txtError != null) {
      <mat-error>{{ txtError }}</mat-error>
    }
  </form>
</div>
<div mat-dialog-actions>
  <button (click)="saveClick()" i18n mat-raised-button>Speichern</button>
  <button (click)="cancelClick()" i18n mat-button>Abbrechen</button>
</div>
